import { generatePath, useNavigate, useParams } from 'react-router';

import {
  useGetDocumentTransitions,
  usePerformDocumentTransition,
} from '~/core/shared/api/documents/hooks';
import { useRootDocumentOrFail } from '~/core/shared/hooks';
import { useEventHandler } from '~/core/shared/hooks/useEventHandler';
import { APPLICATION_ROUTES } from '../../routing/routes';

export const usePerformTransitionAndNavigate = (desiredTransition?: string) => {
  const navigate = useNavigate();
  const { workflow: workflowParam = '' } = useParams<{ workflow?: string }>();
  const rootDocument = useRootDocumentOrFail();
  const { getDocumentTransitions } = useGetDocumentTransitions();
  const { performDocumentTransition } = usePerformDocumentTransition();

  return useEventHandler(async () => {
    const enabledTransitions = await getDocumentTransitions();

    const transition =
      desiredTransition !== undefined
        ? enabledTransitions.find((t) => t === desiredTransition)
        : enabledTransitions[0];

    if (transition) {
      const newPlace = await performDocumentTransition(transition);
      navigate(
        generatePath(APPLICATION_ROUTES.workflowStepPlace.path, {
          document: rootDocument.shortId,
          workflow: workflowParam,
          place: newPlace,
        }),
      );
    }
  });
};
